import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePopupStore = defineStore('popup', () => {
  const isVisible = ref(false)
  const content = ref('')
  const buttonText = ref('')
  const showLogout = ref(false) // Add state for the Logout button
  const onConfirm = ref<(() => void) | null>(null)
  const onLogout = ref<(() => void) | null>(null) // Add a callback for the Logout button

  function show({
    message,
    buttonText: btnText,
    onConfirmAction,
    showLogout: showLogoutButton = false,
    onLogoutAction
  }: {
    message: string
    buttonText?: string
    onConfirmAction?: () => void
    showLogout?: boolean
    onLogoutAction?: () => void
  }) {
    content.value = message
    buttonText.value = btnText || 'OK'
    onConfirm.value = onConfirmAction || null
    showLogout.value = showLogoutButton // Set the state for showing the Logout button
    onLogout.value = onLogoutAction || null
    isVisible.value = true
  }

  function hide() {
    isVisible.value = false
    content.value = ''
    buttonText.value = ''
    showLogout.value = false
    onConfirm.value = null
    onLogout.value = null
  }

  function confirm() {
    if (onConfirm.value) {
      onConfirm.value()
    }
    hide()
  }

  function logout() {
    if (onLogout.value) {
      onLogout.value()
    }
    hide()
  }

  return { isVisible, content, buttonText, showLogout, show, hide, confirm, logout }
})
